export default __webpack_public_path__ + "static/media/4e915dbf941549e58b7ebf48ce582a1f.9628e4ca.png";